import { useMemo } from "react";
import ChipStatus from "../ChipStatus";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const usePublishStatusOptions = () => {
  const { t } = useTranslation();

  return [
    // { id: "init", name: t({ defaultMessage: "初始化" }) },
    { id: "init", name: t({ defaultMessage: "部署中" }) },
    { id: "deploying", name: t({ defaultMessage: "部署中" }) },
    { id: "success", name: t({ defaultMessage: "已完成" }) },
    { id: "ignored", name: t({ defaultMessage: "已忽略" }) },
    { id: "failed", name: t({ defaultMessage: "失败" }) }
  ];
};

const PublishStatus = ({ name, schedule, value, onChange }) => {
  const { t } = useTranslation();
  const options = usePublishStatusOptions();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={schedule ? options.slice(1, -1) : options.slice(1, -2)}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export const PublishChipStatus = ({ status }) => {
  const options = usePublishStatusOptions();
  const option = useMemo(() => {
    return options.find(option => option.id === status);
  }, [status]);

  const type = {
    // init: "default",
    init: "success",
    deploying: "success",
    success: "default",
    failed: "secondary"
  };

  if (!option) {
    return null;
  }

  return <ChipStatus type={type[option.id]} label={option.name} />;
};

export default PublishStatus;
